"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewOrder extends new_item_1.default {
    constructor(newOrder) {
        super();
        this.vat = newOrder.vat;
        this.discount = newOrder.discount;
        this.shippingCost = newOrder.shippingCost;
        this.orgId = newOrder.orgId;
        this.physicalItems = newOrder.physicalItems;
        this.subscriptionItems = newOrder.subscriptionItems;
        this.sessionId = newOrder.sessionId;
    }
}
exports.default = NewOrder;
//# sourceMappingURL=new-order.js.map